<template lang="html">
  <div class="row">
    <div class="col-md-12">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Agregar Equipo</h3>
        </div>
        <div class="panel-body">
          <div class="form-horizontal">
            <div class="form-group">
              <div class="col-md-2">
                <label for="">Nombre</label>
              </div>
              <div class="col-md-8">
                <input type="text" v-model="team.name" class="form-control">
              </div>
              <div class="col-md-2">
                <button type="button" class="btn btn-success" @click="create">Crear</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Team from '../../api/team'
import {
  getConfigChampionship,
  getConfigTeams
} from '../../vuex/getters'
import * as actions from '../../vuex/actions'
export default {
  vuex: {
    getters: {
      championship: getConfigChampionship,
      teams: getConfigTeams
    },
    actions
  },
  data () {
    return {
      team: {
        id: null,
        name: null,
        championship_id: null
      }
    }
  },
  computed: {},
  mounted () {},
  methods: {
    create() {
      this.team.championship_id = this.championship.id
      this.$progress.start()
      let ApiTeam = new Team()
      ApiTeam.post(this.team).then(response => {
        this.team = null
        this.addConfigTeam(response.data)
        this.$progress.finish()
      }, error => {
        this.setError({show: true, message:'Failed saving team'})
        this.$progress.failed()
      })
    }
  },
  components: {}
}
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** TeamNew.vue?289fa6a1
 **/